export * from './colaboradores-list.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/colaboradores/colaboradores-list/index.ts